(function ($, Drupal, drupalSettings) {
  "use strict";

  Drupal.behaviors.ramqMegaMenu = {
    attach: function (context) {

      // Only on HTMLDocument context.
      once('ramqMegaMenu', 'html', context).forEach(function (element) {

        // Styles généraux.
        // Alignement du bouton Services en ligne.
        $("a.services-en-ligne").parent().css("float", "right");

        // 0 - Attribuer le role=button a tout les elemets a + assigner a toutes les balises a tabindex=0 pour qu'elles deviennent focusable.
        $("a.bouton-fantome").attr("role", "button");
        $("a.bouton-fantome").attr("tabindex", "0");

        // 0 - 1.
        $('.bouton-fantome').mouseenter(function () {
          $(this).css({
            'cursor': 'default'
          });
        }).mouseleave(function () {
          $(this).css({
            'cursor': 'default'
          });
        });

        // 1 - Garder le soulignement sur l'élément quand on survol le méga menu.
        $(".mega-menu-tab").hover(
          function () {
            $(this).siblings('.nav-item_bouton').find('a').css("text-decoration", "underline");
          },
          function () {
            $(this).siblings('.nav-item_bouton').find('a').css("text-decoration", "none");
          }
        );
        $(".nav-item_bouton a").hover(
          function () {
            $(this).css("text-decoration", "underline");
          },
          function () {
            $(this).css("text-decoration", "none");
          }
        );

        // 2 - Quand je tabule avec le clavier et je focus sur un element de mega menu tab, l'item principale se souligne.
        $(".mega-menu-tab").on({
          "focusin": function () {
            $(this).siblings('.nav-item_bouton').find('a').css("text-decoration", "underline");
          },
          "focusout": function () {
            $(this).siblings('.nav-item_bouton').find('a').css("text-decoration", "none");
          }
        });

        // 3- Enlever le focus d'absence quebec quand je focus sur 'CITOYENS' - (Nom de classe est changé, détécté le 26 sep 2023)
        //$("a.citoyens-link").on('focus', function () {
        $("a.nav-link").on('focus', function () {
          $('.section-assurance-maladie').removeClass('hover-active');
        });

        // 4 - Focus le bouton fantôme.
        $('.bouton-fantome a').on('focus', function () {
          $('.nav-item_bouton > a').not(this).removeClass('hover-active');
          $(this).parents('.nav-item_bouton').find('a').addClass('hover-active');
        });

        // 5 - Focus sur le titre de menu + soulignement lors de la tabulation.
        $('.nav-item_bouton > a').on('focus', function () {
          $(this).css("text-decoration", "underline");
          $('.nav-item_bouton > a').not(this).removeClass('hover-active');
          if (!$(this).hasClass('services-en-ligne')) {
            $(this).addClass('hover-active');
          }
        });

        // 6 - Enlever le soulignement quand le focus quitte l'élément.
        /*$('.nav-item_bouton a').on('blur', function () {
          $(this).css("text-decoration", "none");
        });*/

        // Correction 08 mai 2024 (4ème correction de figma).
        $('.nav-item_bouton a.bouton-fantome').on('blur', function () {
          $(this).closest('.nav-item_bouton').find('a').css("text-decoration", "none");
        });

        $('.nav-item_bouton a.bouton-fantome').on('focus', function () {
          $('.nav-item_bouton').find('a').css("text-decoration", "none");
          $(this).closest('.nav-item_bouton').find('a').css("text-decoration", "underline");
        });


        // 7 - Focus sur les éléments qui composent chaque sous menu.
        $('#sous-menu_Absence_du_Québec a').addClass('absence-du-quebec');
        $('#sous-menu_Assurance_maladie a').addClass('assurance-maladie');
        $('#sous-menu_Assurance_médicaments a').addClass('assurance-medicaments');
        $('#sous-menu_Programmes_d’aide a').addClass('programme-aide');
        // On focus event.
        $('a.absence-du-quebec').on('focus', function () {
          $('a.section-absence-du-quebec').addClass('hover-active');
        });
        $('a.assurance-maladie').on('focus', function () {
          $('a.section-assurance-maladie').addClass('hover-active');
        });
        $('a.assurance-medicaments').on('focus', function () {
          $('a.section-assurance-medicaments').addClass('hover-active');
        });
        $('a.programme-aide').on('focus', function () {
          $('a.section-programme-daide').addClass('hover-active');
        });

        // 8 - GRANDE PARTIE DÉPLACÉE

        // Détecter le mouseleave -hide est desactiver pour que le slidedown ne s'applique pas tout le temps.
        $('.block--mega-menu .mega-menu-main, .block--mega-menu .lvl-0').mouseleave(function (e) {
          $("a").removeClass('hover-active');
          //$('.sous-menu_paneau').css("height", 0); //  15 mai 2024 (Nawfal)
        });

        // Ajouté par Nawfal : Détecter le mouseleave pour fermer le panneau de sous-menu quand on quitte la div ayant .mega-menu-main.
        $('.block--mega-menu .mega-menu-main, .block--mega-menu .lvl-0:last').mouseleave(function (e) {
          if (!$(e.relatedTarget).hasClass('bouton-fantome') && !$(e.relatedTarget).hasClass('lvl-0')) {
            closeSubMenus();
          }
        });

        // Détecter le hover du panneau de sous-menu.
        $('.block--mega-menu .mega-menu-main > li.lvl-0').each(function () {
          $(this).mouseenter(function (e) {
            openSubMenu(this, e);
          });
        });

        // Clic.
        $('.block--mega-menu a.bouton-fantome, .block--mega-menu-2 .bouton-fantome').on("click", function (e) {
          toggleSubMenu(this, e);
        });

        // Focus.
        // 9 - Cacher le mega menu tab et sous menu panneau quand on focus un item de menu avec le clavier.
        $('.block--mega-menu .mega-menu-main a.submenu-item, .block--mega-menu-2 .mega-menu-main a.submenu-item').each(function (e) {
          $(this).on('focus', function (e) {
            closeSubMenus();
          });
        });

        // Masquer le sous-panneau en cas de clic en dehors du mega menu.
        var container = $('.lvl-0');
        $(window).click(function (e) {
          // Pour le site Citoyens seulement.
          if (isSitePro()) return;
          // Si un sous-menu est ouvert seulement.
          if ($('.lvl-0.sous-menu-active').length === 0) return;
          // Si le clic est hors zone seulement.
          if (!container.is(e.target) && container.has(e.target).length === 0) {
            closeSubMenus();
          }
        });

        // Tente de déterminer si nous sommes sur le site Pro.
        function isSitePro() {
          // Citoyens : nav#block-mega-menu
          // Professionnels : nav#block-ramqmegamenupro, nav#block-menu-du-site-professionnels-actualites-nous-joindre
          return ($('nav#block-mega-menu').length === 0);
        }

        /* Open Sub-Menu */
        function openSubMenu(element, event) {

          // Obtenir la hauteur du panneau.
          $(".mega-menu-tab").removeAttr("style");
          var height = 0;
          var myelement = $(element).find('.mega-menu-tab');
          if ($(myelement).length) {
            $(myelement).css("display", "flex");
            height = $(myelement).outerHeight(true);
          }

          // Refermer les autres.
          $('li.lvl-0').removeClass('sous-menu-active'); // Cela permet d'éviter le chevauchement des éléments lors de l'utilisation d'une tabulation.
          $("a").removeClass('hover-active'); // Aussi, Cela permet d'éviter le chevauchement des éléments lors de l'utilisation d'une tabulation.

          // Ouvrir le panneau.
          $(element).find('a').addClass('hover-active'); // Cela permet de garder la ligne orange aprés qu'on rentre dans le mega-menu-tab
          $('.sous-menu_paneau').css("height", height);
          $(element).addClass('sous-menu-active');

          // Arrière-plan blanc.
          if ($('.sous-menu_paneau').css('display') === 'none') {
            $('.sous-menu_paneau').css('margin-top', '1px').slideDown(100); // 100 au lieu 150 - 2eme Correction 08 mai 2024 (2eme correction de figma)
            $('.sous-menu_paneau').css('display', 'block')
            $("a.bouton-fantome").attr('aria-expanded', "true");
          }
        }

        /* Close Sub-Menu */
        function closeSubMenus() {

          // Refermer tout.
          //container.not($(this).closest('.lvl-0')).removeClass('sous-menu-active');
          $('.lvl-0').removeClass('sous-menu-active');
          $("a.bouton-fantome").attr('aria-expanded', "false");
          //$(".lvl-0 .mega-menu-tab").css("display", "none");
          $(".lvl-0 .mega-menu-tab").hide(0, function () {
            //$('.sous-menu_paneau').hide();
            $('.sous-menu_paneau').slideUp(150);
          });
        }

        /* Open & close drop-down list */
        // Fonction pour ouvrir et fermer les sous-menus.
        function toggleSubMenu(element, event) {

          // @TODO: Vérifier si requis.
          event.preventDefault();
          var current = $(element).closest('.lvl-0');

          // Toggle.
          if ($(current).hasClass('sous-menu-active')) {
            closeSubMenus();
          }
          else {
            openSubMenu(current, event);
          }
        }

      });
    }
  };

  // Gestion Écran Mobile TOUCHEND.
  Drupal.behaviors.ramqOuvertureSousMenu = {
    attach: function (context) {

      // Tente de déterminer si nous sommes sur le site Pro.
      function isSitePro() {
        // Citoyens : nav#block-mega-menu
        // Professionnels : nav#block-ramqmegamenupro, nav#block-menu-du-site-professionnels-actualites-nous-joindre
        return ($('nav#block-mega-menu').length === 0);
      }

      // Pour le site Citoyens seulement.
      if (isSitePro()) return;

      // Only on HTMLDocument context.
      once('ramqOuvertureSousMenu', 'html', context).forEach(function (element) {

        $(element).on("touchend", function (event) {

          // Check si le menu de la section Citoyen
          var targetEstUnItemDeMenuPourSectionCitoyen = $(event.target).closest('.block--mega-menu-2').length > 0;

          var targetEstUnItemDeMenuPourSection = $(event.target).hasClass("submenu-item");
          var targetEstUnEnfantDeItemDeMenuPourSection = $(event.target).parents().parents("a.submenu-item").not("a.services-en-ligne").length !== 0;
          var targetEstUnFrereDeItemDeMenuPourSection = $(event.target).hasClass("bouton-fantome");
          if (targetEstUnItemDeMenuPourSection || targetEstUnEnfantDeItemDeMenuPourSection || targetEstUnFrereDeItemDeMenuPourSection) {
            var itemDeMenuPourSections = $(event.target).parents("li.lvl-0");

            // Si le sous-menu est déjà affiché au moment du touch sur le lien
            if (itemDeMenuPourSections.hasClass('sous-menu-active')) {
              event.preventDefault();
              itemDeMenuPourSections.removeClass('sous-menu-active');
              $(this).find('.link-title').css('text-decoration', 'none'); // TRES IMPORTANT - 09-07-2024 (soulignement des titres dans les petits ecran)
              itemDeMenuPourSections.find('.link-title').css('text-decoration', 'none'); // TRES IMPORTANT - 09-07-2024 (soulignement des titres dans les petits ecran)
            } else {
              // Si le sous-menu n'est pas déjà affiché au moment du touch sur le lien sur la section citoyen
              if (targetEstUnItemDeMenuPourSectionCitoyen)
                event.preventDefault();
              // On affiche le sous menu
              $('.lvl-0').removeClass('sous-menu-active');
              itemDeMenuPourSections.addClass('sous-menu-active');
              $(this).find('.link-title').css('text-decoration', 'none'); // TRES IMPORTANT - 09-07-2024 (soulignement des titres dans les petits ecran)
              itemDeMenuPourSections.find('.link-title').css('text-decoration', 'underline'); // TRES IMPORTANT - 09-07-2024 (soulignement des titres dans les petits ecran)
            }
          }
        });
      });
    }
  };

  // Corrige des problèmes d'accessibilité soulevés par Patrick, lors d'un zoom 200% sur Firefox en mode Zoom Text Only
  // Voir le ticket #15152 sur Azure DevOps pour plus de détails
  Drupal.behaviors.fix15152SousMenu = {
    attach: function (context) {
      // Only on HTMLDocument context.
      once('fix15152SousMenu2', 'html', context).forEach(function (element) {
        var normalFooterH2FontSize = 48;
        $(window).on("resize", function () {
          var fs = parseFloat(
            $("footer .footer_titre-niveau2", context).css("font-size")
          );
          fixMenu(fs);
          fix15155CercleOrange(fs);
        });
        $(document).on("DOMMouseScroll", function (event) {
          if (event.ctrlKey) {
            var fs = parseFloat(
              $("footer .footer_titre-niveau2", context).css("font-size")
            );
            fixMenu(fs);
            fix15155CercleOrange(fs);
          }
        });
        $(document).keyup(function (event) {
          if (
            event.ctrlKey && [48, 61, 96, 107, 109, 173, 187, 189].indexOf(event.which) !== -1
          ) {
            var fs = parseFloat(
              $("footer .footer_titre-niveau2", context).css("font-size")
            );
            fixMenu(fs);
            fix15155CercleOrange(fs);
          }
        });
        var fontSize = parseFloat(
          $("footer .footer_titre-niveau2", context).css("font-size")
        );
        fixMenu(fontSize);
        fix15155CercleOrange(fontSize);

        function fixMenu(actualFooterH2FontSize) {
          if (
            window.matchMedia("(min-width: 769px)").matches &&
            actualFooterH2FontSize > normalFooterH2FontSize
          ) {
            $(".navbar.navbar-expand-lg", context).removeClass(
              "navbar-expand-lg"
            );
            $(".navbar:not(.not-lg)", context).addClass("not-lg");
            $(".navbar > .container:not(.not-lg)", context).addClass("not-lg");
            $(".navbar-heading-logo-wrapper", context).addClass("not-lg not-xl");
            $(".navbar-search-button-wrapper", context).addClass("not-lg not-xl");
            $(
              ".navbar-links-desktop.d-none.d-lg-block.d-xl-block",
              context
            ).removeClass("d-lg-block d-xl-block");
            $(".page__menu.d-none.d-lg-block.d-xl-block", context).removeClass(
              "d-lg-block d-xl-block"
            );
            $(".navbar-links-mobile.d-lg-none.d-xl-none", context).removeClass(
              "d-lg-none d-xl-none"
            );
          } else {
            $(".navbar:not(.navbar-expand-lg)", context).addClass(
              "navbar-expand-lg"
            );
            $(".navbar.not-lg", context).removeClass("not-lg");
            $(".navbar > .container.not-lg", context).removeClass("not-lg");
            $(".navbar-heading-logo-wrapper.not-lg.not-xl", context).removeClass(
              "not-lg not-xl"
            );
            $(".navbar-search-button-wrapper.not-lg.not-xl", context).removeClass(
              "not-lg not-xl"
            );
            $(".navbar-links-desktop.d-none:not(.d-lg-block)", context).addClass(
              "d-lg-block d-xl-block"
            );
            $(".page__menu.d-none:not(.d-lg-block)", context).addClass(
              "d-lg-block d-xl-block"
            );
            $(".navbar-links-mobile:not(.d-lg-none)", context).addClass(
              "d-lg-none d-xl-none"
            );
          }
        }

        function fix15155CercleOrange(fontSize) {
          if (fontSize >= 2 * normalFooterH2FontSize) {
            $(".page__content .liste-lien-action li", context)
              .removeClass("li-md-lg")
              .addClass("li-xs-sm");
          } else if (fontSize >= 1.4 * normalFooterH2FontSize) {
            $(".page__content .liste-lien-action li", context)
              .removeClass("li-xs-sm")
              .addClass("li-md-lg");
          } else {
            $(".page__content .liste-lien-action li", context).removeClass(
              "li-xs-sm li-md-lg"
            );
          }
        }
      });
    }
  };

  Drupal.behaviors.fix15152SousMenu = {
    attach: function (context) {
      // Only on HTMLDocument context.
      once('fix15152SousMenu', 'html', context).forEach(function (element) {
        $("nav.container").attr("aria-label", "Principal");
      });
    }
  };

  // Changer la confirmation de suppression du contenu rupture de stock (Cette fonction ne fait pas parti du Menu)
  Drupal.behaviors.ruptureDeStock = {
    attach: function (context, settings) {

      $('.alert.alert-success.alert-dismissible[role="alert"]', context).once('ruptureDeStock').each(function () {

        // Modifier uniquement le texte exact au début du contenu
        $(this).contents().filter(function () {
          return this.nodeType === 3 && this.nodeValue.trim().startsWith('Le Rupture de stock');
        }).each(function () {
          this.nodeValue = this.nodeValue.replace('Le Rupture de stock', 'Le contenu rupture de stock');
        });
      });

      //$('article.node--promoted.rupture-de-stock.rupture-de-stock--full').addClass('container');
      // Ajouter la classe "container" et le padding-left de 35px à l'article rupture de stock affiché en mode plein
      $('article.node--promoted.rupture-de-stock.rupture-de-stock--full', context)
        .addClass('container')
        .css('padding-left', '35px');

    }
  };

})(jQuery, Drupal, drupalSettings);
